import { useNavigate } from 'react-router-dom';

export default function PlataformaRecursos() {
  const navigate = useNavigate();

  return (
    <>
      {/* Discriminação de Crédito */}
      <section id="credito" className="scroll-mt-28 bg-background-100 py-20 md:py-28">
        <div className="mx-auto w-full max-w-[1240px] px-6">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-accent-700">
                <i className="ri-fingerprint-line"></i>
                Discriminação de crédito
              </span>
              <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-4xl">
                Cada premiação tem uma origem.
                <br />
                <span className="text-accent-600">Cada crédito pode ser rastreado.</span>
              </h2>
              <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600">
                A GetPoints relaciona a premiação às informações que deram origem ao crédito — contrato, empresa,
                produto, vidas, corretor e campanha. Isso cria uma trilha de auditoria da premiação, com transparência
                total para financeiro, controladoria e auditoria.
              </p>

              <ul className="mt-8 space-y-3">
                {[
                  'Trilha de auditoria completa da origem de cada premiação',
                  'Controle de elegibilidade vinculado aos contratos comercializados',
                  'Lotes de premiação com meta, produtos e valores detalhados',
                  'Conformidade e rastreabilidade em cada crédito gerado',
                ].map((item) => (
                  <li key={item} className="flex items-center gap-3 text-sm text-foreground-700">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-500 text-white">
                      <i className="ri-check-line text-base font-bold"></i>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="w-full overflow-hidden rounded-3xl border border-background-200 bg-background-50">
              <img
                src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/e53c05842c56551f6f455b93eb71bf92.png"
                alt="Detalhes do crédito com origem da premiação, histórico de crédito e comprovante de crédito rastreável e auditável da plataforma get points"
                title="Detalhes do crédito e comprovante de premiação rastreável"
                className="block h-auto w-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Gestão do Prêmio */}
      <section id="gestao-premio" className="scroll-mt-28 bg-background-50 py-20 md:py-28">
        <div className="mx-auto w-full max-w-[1240px] px-6">
          <div className="mx-auto mb-14 max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
              <i className="ri-gift-line"></i>
              Gestão do prêmio
            </span>
            <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
              Do crédito ao resgate, <span className="text-primary-600">sem fricção</span>
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-600">
              Créditos disponíveis, catálogo de recompensas, carteira digital e comprovantes — todo o ciclo de
              premiação gerenciado em um só lugar, com a menor taxa do mercado.
            </p>
          </div>

          <div className="grid gap-5 lg:grid-cols-3">
            {/* Créditos disponíveis */}
            <figure className="aspect-[400/502] overflow-hidden rounded-3xl border border-background-200 bg-background-100">
              <img
                src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/ebabdf0b68b02079447a960b2f9d9aef.png"
                alt="Créditos disponíveis na carteira get points com saldo, bônus de meta de vendas, comissão e bônus trimestral prontos para resgate"
                title="Créditos disponíveis na plataforma get points"
                className="h-full w-full object-cover object-left"
              />
            </figure>

            {/* Catálogo */}
            <figure className="aspect-[400/502] overflow-hidden rounded-3xl border border-background-200 bg-background-100">
              <img
                src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/ebabdf0b68b02079447a960b2f9d9aef.png"
                alt="Catálogo de recompensas get points com PIX, pagamento de contas, produtos, vouchers e experiências para resgate"
                title="Catálogo de recompensas get points"
                className="h-full w-full object-cover object-center"
              />
            </figure>

            {/* Resgates */}
            <figure className="aspect-[400/502] overflow-hidden rounded-3xl border border-background-200 bg-background-100">
              <img
                src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/ebabdf0b68b02079447a960b2f9d9aef.png"
                alt="Resgates e comprovantes get points com protocolo, status, nota fiscal automática, histórico completo e auditoria rastreável"
                title="Resgates e comprovantes get points"
                className="h-full w-full object-cover object-right"
              />
            </figure>
          </div>
        </div>
      </section>

      {/* Autorizações e Alçadas */}
      <section id="autorizacoes" className="scroll-mt-28 bg-background-100 py-20 md:py-28">
        <div className="mx-auto w-full max-w-[1240px] px-6">
          <div className="mx-auto mb-14 max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
              <i className="ri-shield-check-line"></i>
              Autorizações e alçadas
            </span>
          </div>
        </div>

        <div className="mx-auto w-full max-w-[1520px] px-6">
          <div className="w-full overflow-hidden rounded-3xl border border-background-200 bg-background-50">
            <img
              src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/68a40511a6aa5fe14d5d742c2a049c17.png"
              alt="Governança get points com aprovação e rastreio: fila de aprovação de saques, créditos e estornos, hierarquia de aprovação por plataforma, empresa, campanha e participante, e controles de segurança com KYC, 2FA, webhooks assinados e prazo de aprovação"
              title="Governança com aprovação e rastreio na plataforma get points"
              className="block h-auto w-full"
            />
          </div>
        </div>

        <div className="mx-auto w-full max-w-[1240px] px-6">
          <div className="mt-12 flex flex-col items-center gap-4 text-center">
            <p className="max-w-2xl text-base text-foreground-600">
              Quer ver esses recursos rodando no seu cenário? Fale com um especialista e monte um piloto em dias.
            </p>
            <button
              type="button"
              onClick={() => navigate('/solicitar-demo')}
              className="inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
            >
              Agendar uma demonstração
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>
        </div>
      </section>
    </>
  );
}